export default function MalencoNaw() {
  return (
      <>
          <span>&copy; 2025 Malenco Automatisering b.v.</span><br />
          <span>&#9742; +31 (0)72 567 55 66</span> | {" "}
          <span>&#9993; protection@malenco.nl</span> | {" "}
          <span>KvK: 89563239</span> |{" "}
          <span>BTW: NL865022276B01</span>
      </>
  );
}
